module.exports = __webpack_public_path__ + "static/media/logo-white.09e2b364.svg";